import * as React from "react";

import FilterPanel from "./FilterPanel";
import FilterTitleBar from "./FilterTitleBar";
import DataTable from "./../containers/DataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addFonts } from "./../assets/Icons";
addFonts();

export interface Props {
  filters: Function;
}

interface State {
  filterCollapsed: boolean;
}

class MainContent extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { filterCollapsed: false };
    this.toggleFilterCollapse = this.toggleFilterCollapse.bind(this);
  }

  toggleFilterCollapse() {
    this.setState({ filterCollapsed: !this.state.filterCollapsed });
  }

  render() {
    const collapsedFilterTab = (
      <div
        className="ds-c-tabs ds-u-padding-right--2 ds-u-padding--top-3"
        role="tab"
        aria-selected="false"
        id="tab-filters-link-id"
      >
        <div>
          <div className="collapseScreen">
            <FilterTitleBar
              collapsed={this.state.filterCollapsed}
              onClick={this.toggleFilterCollapse}
            />
          </div>
        </div>
      </div>
    );

    const tableTab = (
      <a
        className="ds-c-tabs__item"
        href="#panel-table-view"
        role="tab"
        aria-selected="true"
        id="tab-table-view-link-id"
      >
        <div>
          <FontAwesomeIcon icon="university" /> Institution View
        </div>
      </a>
    );

    let filterColClass, filterTab, tableColClass, filterColStatus;
    if (this.state.filterCollapsed) {
      filterTab = collapsedFilterTab;
      filterColClass = "ds-l-md-col--12 printOnly";
      filterColStatus = "collapsed";
      tableColClass = "ds-l-md-col--12";
    } else {
      filterColClass = "ds-l-md-col--3  ds-u-padding-right--0";
      filterColStatus = "open";
      tableColClass = "ds-l-md-col--9";
    }

    return (
      <div
        className={`ds-l-row ds-u-margin-bottom--3 ${filterColStatus}`}
        id="fitlerPanels"
      >
        <div className={filterColClass}>
          <FilterPanel
            filters={this.props.filters}
            onTitleClick={this.toggleFilterCollapse}
          />
        </div>
        <div className={tableColClass}>
          <div className="ds-c-tabs" role="tablist" aria-label="Settings">
            {filterTab}
            {tableTab}
          </div>
          <DataTable />
        </div>
      </div>
    );
  }
}

export default MainContent;
